export default {
  EMAILJS_SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  EMAILJS_TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  EMAILJS_PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  COMPANY_INFO: {
    address: {
      zip: '10115',
      street: 'Torstraße 201',
      city: 'Berlin',
    },
    phone: '+49 30 76957235',
  },
};
